module.exports = __webpack_public_path__ + "static/media/AuTravailAvecAlainLouvier2012.3709223b.JPG";